/**
 * viem chain definitions + shared clients. Gnosis comes from viem; Robinhood
 * Chain (Arbitrum Orbit L2, live 2026-07-01) is defined here from verified
 * values (docs/RESEARCH.md).
 */
import { createPublicClient, createWalletClient, defineChain, http, type Account } from "viem";
import { gnosis } from "viem/chains";
import { ROBINHOOD_CHAIN } from "./config";

export const robinhoodChain = defineChain({
  id: ROBINHOOD_CHAIN.id,
  name: ROBINHOOD_CHAIN.name,
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: [...ROBINHOOD_CHAIN.rpcUrls] } },
  blockExplorers: { default: { name: "Blockscout", url: ROBINHOOD_CHAIN.explorer } },
});

export function robinhoodPublicClient() {
  return createPublicClient({ chain: robinhoodChain, transport: http(undefined, { timeout: 20_000 }) });
}

export function gnosisPublicClient() {
  return createPublicClient({ chain: gnosis, transport: http(undefined, { timeout: 20_000 }) });
}

export function gnosisWalletClient(account: Account) {
  return createWalletClient({ chain: gnosis, account, transport: http(undefined, { timeout: 30_000 }) });
}

export function walletClientFor(chainId: number, account: Account) {
  const chain = chainId === ROBINHOOD_CHAIN.id ? robinhoodChain : gnosis;
  return createWalletClient({ chain, account, transport: http(undefined, { timeout: 30_000 }) });
}
